import { TrusteeInfo } from '../../types';
import { AddressType, TrusteePersonType } from '../constants';
import { CountryCode } from '@agentnet/utils';

export const getInitialTrusteeData = (): TrusteeInfo => ({
  personType: TrusteePersonType.Individual,
  firstName: '',
  middleName: '',
  lastName: '',
  suffix: '',
  dateOfBirth: '',
  entityLegalName: '',
  alternateNames: [''],
  address: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: CountryCode.US,
    postalCode: '',
  },
  addressType: AddressType.Foreign, // Default to "Principal Place of Business (U.S.)"
  foreignBusinessNoUSLocation: false,
  primaryUSAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: CountryCode.US,
    postalCode: '',
  },
  foreignBusinessAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: CountryCode.US,
    postalCode: '',
  },
  foreignPrincipalAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: CountryCode.US,
    postalCode: '',
  },
  foreignEntity: false,
  identification: { type: '', number: '', jurisdiction: '' },
  status: 'incomplete',
  expanded: true,
});
